import { Injectable } from '@angular/core';

import { BaseService } from './base.service';
import { ReviewGroup } from '../model/review-group.model';

@Injectable()
export class ReviewGroupService {
	constructor(private baseService: BaseService) {}

	path = '/review-group/';

	save = (value: any) => value.id ? this.put(value) : this.post(value);

	getAll = () => this.baseService.get(this.path, '');

	getById = (id: number) => this.baseService.get(this.path, '' + id);

	post = (value: ReviewGroup) => this.baseService.post(this.path, '', value);

	put = (value: ReviewGroup) => this.baseService.put(this.path, '', value);
	
	delete = (id: number) => this.baseService.delete(this.path, '' + id);
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/review-group.service.ts